var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:""},[(_vm.$store.main.state.userToken)?_c('feed'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }